import { createContext, Dispatch, SetStateAction, useContext } from "react";

import type { Row } from "../columns";

export type EpcraBulkDialogState = "assignee" | "status" | "notes" | "verify" | null;

export const epcraBulkActionContext = createContext<{
  selectedRows: Row[];
  dialogState: EpcraBulkDialogState;
  setDialogState: Dispatch<SetStateAction<EpcraBulkDialogState>>;
  onClose: () => void;
  onSuccess: () => void;
}>({
  selectedRows: [],
  dialogState: null,
  setDialogState: () => {},
  onClose: () => {},
  onSuccess: () => {},
});

export function useEpcraBulkActionContext() {
  return useContext(epcraBulkActionContext);
}
